import './header.css';

function Header() {
  return (
    <div id='home' className='container header-container'>
      <h3>
        <p>
          I<span>'</span>m
        </p>
        Sergio
      </h3>
      <h2>Front-End Web Developer</h2>
    </div>
  );
}
export default Header;